<!-- 艺术品推荐 -->
<template>
  <div class="home_component news_and_info fd_column">
    <div class="component_title m-b-30">
      <div class="title_mid">
        <div class="title">艺术品推荐</div>
        <div class="subtitle">Art Recommendation</div>
        <div class="viewMore_more" @click="linkJump(2, '/Artbuying')">
          查看更多
        </div>
      </div>
    </div>
    <div class="component_box">
      <div class="inner_box">
        <div
          class="inner_m"
          style="position: relative;margin-bottom: 0.3125rem;"
          v-for="(item, index) in projectRight"
          :key="index"
          @click="
            scrollRecord('Home', 'Home');
            linkJump(1, '/ArtbuyingDetail', { id: item.id });
          "
        >
          <div
            :class="getClass(index)"
            @mouseover="showOver(index)"
            @mouseout="showOut()"
          >
            <img class="artwork_img" :src="imgApi + item.artImg" alt="" />
            <img
              class="artwork"
              src="@/assets/home/Policy/art_collection.png"
              alt=""
            />
            <div
              class="artwork_contemt"
              :style="{
                bottom: subActive == index ? '0rem' : '-.5208rem',
              }"
            >
              <div>{{ item.theDesc }}</div>
            </div>
          </div>
          <div class="artwork_title_name">
            <div class="artwork_title">{{ item.artName }}</div>
            <div class="artwork_name">{{ item.artistName }}</div>
          </div>
        </div>
      </div>
      <div @click="linkJump(1, '/Artbuying')" class="view_more">
        <div>查看更多</div>
        <img src="@/assets/common/view_more.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import { getList } from "@/api/Home/ArtRecommendation";
export default {
  // import引入的组件需要注入到对象中才能使用
  // components: {Empty},
  data() {
    // 这里存放数据
    return {
      imgApi: process.env.VUE_APP_BASE_IMAGE,
      isActive: false,
      subActive: null,
      projectRight: [],
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    showOver(index) {
      this.subActive = index;
    },
    showOut() {
      this.subActive = null;
    },
    getClass(index) {
      if (index % 3 === 0) {
        return "artwork_class";
      } else {
        return "artwork_box";
      }
    },
    async getList() {
      const res = await getList();
      if (res.code === 1) {
        this.projectRight = res.data;
      }
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getList();
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
// @import url(); 引入公共css类
@import "~@/static/styles/variables.less";
@import "~@/static/styles/index.less";
.home_component {
  .m-b-30 {
    margin-bottom: 0.3125rem;
  }
}
.component_box {
  position: relative;
  box-sizing: border-box;
  .normal_flex;
  background-color: transparent;
  border-radius: 6px 6px 6px 6px;
  .pane_box {
    margin-top: 30px;
    width: 100%;
    height: 416px;
    display: flex;
    justify-content: space-between;
    .pane_left,
    .pane_right {
      width: 700px;
      height: 416px;
      border-radius: 6px 6px 6px 6px;
    }
    .pane_right {
      box-sizing: border-box;
      background-color: #fff;
      padding: 30px;
      .line {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
        .title {
          width: 460px;
          font-size: 16px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #323233;
          line-height: 27px;
        }
        .time {
          font-size: 16px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #969799;
          line-height: 27px;
        }
      }
    }
  }
  .arrow {
    position: absolute;
    width: 44px;
    height: 44px;
    border: none;
    &.arrow_left {
      left: -84px;
      top: 50%;
      transform: translateY(-50%);
    }
    &.arrow_right {
      right: -84px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}
.news_and_info {
  .artwork_title_name {
    display: flex;
    align-items: center;
    margin-top: 0.1563rem;
    justify-content: space-between;
  }
  .component_box {
    position: relative;
    width: 100%;
    flex-direction: column;
    .more {
      position: absolute;
      top: 0;
      right: 0;
      line-height: 40px;
      font-size: 14px;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #969799;
      line-height: 16px;
    }
    .inner_box {
      column-count: 2;
      column-gap: 0.2604rem;
      .inner_m {
        position: relative;
        margin-bottom: 0.3125rem;
      }
      .inner_left {
        overflow: scroll;
        position: relative;
        box-sizing: border-box;
        padding-top: 20px;
        width: 295px;
        height: 678px;
        background: #ffffff;
        box-shadow: 0px 2px 26px -1px rgba(0, 0, 0, 0.08);
        border-radius: 10px 10px 10px 10px;
        .high_bg {
          position: absolute;
          right: 0;
          bottom: 0;
          width: 128px;
          height: 156px;
        }
        .cat_bar {
          cursor: pointer;
          padding: 20px 0;
          display: flex;
          justify-content: space-between;
          align-items: center;
          position: relative;
          // height
          .cat_title {
            display: flex;
            flex: 1;
            justify-content: space-between;
            align-items: center;
            margin-left: 40px;
            margin-right: 36px;
            font-size: 20px;
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 700;
            color: #2c2c2c;
            line-height: 23px;
          }
          .el-icon-arrow-up {
            opacity: 0;
          }
          img {
            display: none;
          }
        }
        .cat_bar.isActive {
          padding: 0;
          height: 70px;
          background: linear-gradient(
            90deg,
            #ffeeee 0%,
            rgba(255, 238, 238, 0) 100%
          );
          .cat_title {
            display: flex;
            flex: 1;
            justify-content: space-between;
            align-items: center;
            margin-left: 40px;
            margin-right: 36px;
            font-size: 20px;
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 700;
            color: linear-gradient(90deg, #68a4ff 0%, #166df0 100%);
            line-height: 23px;
          }
          .el-icon-arrow-up {
            opacity: 1;
          }
          img {
            display: block;
            width: 70px;
            height: 70px;
          }

          &::before {
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            content: "";
            width: 3px;
            height: 40px;
            background: linear-gradient(90deg, #68a4ff 0%, #166df0 100%);
          }
        }
        .cat_sub {
          display: flex;
          padding-left: 70px;
          opacity: 0;
          flex-direction: column;
          justify-content: flex-start;
          gap: 30px;
          max-height: 0px;
          transition: all 0.8s;
          overflow: scroll;
          .cat_sub_item {
            cursor: pointer;
            font-size: 20px;
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 400;
            color: #666666;
            line-height: 23px;
            &:hover {
              color: linear-gradient(90deg, #68a4ff 0%, #166df0 100%);
            }
            &.isActive {
              color: linear-gradient(90deg, #68a4ff 0%, #166df0 100%);
            }
          }
          &.isActive {
            padding: 20px 0;
            padding-left: 70px;
            opacity: 1;
            transition: all 0.8s ease-in-out;
            display: flex;
            max-height: 350px;
          }
        }
      }
      .inner_right {
        box-sizing: border-box;
        padding: 30px;
        width: 1125px;
        height: 678px;
        background: #ffffff;
        box-shadow: 0px 2px 26px -1px rgba(0, 0, 0, 0.08);
        border-radius: 10px 10px 10px 10px;
        .policy_boxes {
          display: flex;
          flex-wrap: wrap;
          gap: 30px 30px;
        }
        .policy_box {
          cursor: pointer;
          box-sizing: border-box;
          padding: 0 20px;
          display: flex;
          flex-direction: column;
          width: 335px;
          height: 186px;
          transition: background 0.6s;
          box-shadow: 0px 2px 26px -1px rgba(0, 0, 0, 0.08);
          border-radius: 6px 6px 6px 6px;
          &:hover {
            .state_tag {
              .state_tag_box {
                background: #ffffff60 !important;
                color: #ffffff !important;
              }
            }
            .policy_title {
              color: #fff;
            }
            .time_tag {
              .time_tag_box {
                border: 1px solid #fff;
                color: #fff;
              }
            }
            .policy_footer {
              .policy_footer_text {
                color: #fff;
              }
            }
          }
          .state_tag {
            position: relative;
            width: 100%;
            height: 32px;
            .state_tag_box {
              position: absolute;
              top: 0;
              right: -20px;
              display: flex;
              justify-content: center;
              align-items: center;
              width: 67px;
              height: 32px;
              background: #66666610;
              border-radius: 0px 6px 0px 6px;
              font-size: 14px;
              font-family: YouSheBiaoTiHei, YouSheBiaoTiHei;
              font-weight: 400;
              color: #666666;
              line-height: 16px;
              &.state1 {
                background: rgba(255, 152, 0, 0.11);
                color: #ff9800;
              }
              &.state2 {
                background: rgba(70, 185, 66, 0.11);
                color: #46b942;
              }
            }
          }
          .policy_title {
            width: 100%;
            height: 52px;
            margin-top: 5px;
            font-size: 20px;
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 500;
            color: #333333;
            line-height: 26px;
            .text_overflow_hidden_lines(2);
          }
          .time_tag {
            margin: 16px 0;
            display: flex;
            .time_tag_box {
              padding: 0 8px;
              display: flex;
              justify-content: center;
              align-items: center;
              width: auto;
              height: 27px;
              border-radius: 2px 2px 2px 2px;
              opacity: 1;
              border: 1px solid linear-gradient(90deg, #68a4ff 0%, #166df0 100%);
              font-size: 14px;
              font-family: Source Han Sans CN, Source Han Sans CN;
              font-weight: 400;
              color: linear-gradient(90deg, #68a4ff 0%, #166df0 100%);
            }
          }
          .policy_footer {
            flex: 1;
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-top: 1px solid #f0f0f0;
            .policy_footer_text {
              font-size: 12px;
              font-family: Source Han Sans CN, Source Han Sans CN;
              font-weight: 400;
              color: #999999;
              line-height: 14px;
            }
            .policy_footer_left {
            }
            .policy_footer_right {
            }
          }
        }
      }
      .artwork_box {
        width: 3.5938rem;
        height: 3.5rem;
        border-radius: 10px;
        overflow: hidden;
        position: relative;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
      }
      .artwork_class {
        width: 3.5938rem;
        height: 2.2448rem;
        border-radius: 10px;
        overflow: hidden;
        position: relative;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
      }
      .artwork_img {
        width: 100%;
        height: 100%;
        border-radius: 0.0521rem;
        object-fit: cover;
      }
      .artwork {
        position: absolute;
        width: 0.2604rem;
        height: 0.2604rem;
        top: 0.2083rem;
        left: 0.2083rem;
        cursor: pointer;
      }
      .artwork_title {
        font-family: Source-Medium;
        font-weight: 500;
        font-size: 0.125rem;
        color: #333333;
      }
      .artwork_name {
        font-family: Source-Regular;
        font-weight: 400;
        font-size: 0.0938rem;
        color: #999999;
      }
      .artwork_contemt {
        width: 100%;
        height: 0.3125rem;
        background: rgba(78, 78, 78, 0.4);
        position: absolute;
        bottom: 100%;
        box-sizing: border-box;
        transition: all 0.3s;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: .1042rem .1042rem;
        div {
          font-family: Source-Regular;
          font-size: 0.0938rem;
          color: #ffffff;
          font-weight: 400;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
      }
      .subActive {
        bottom: 0;
      }
    }
    ::v-deep {
      .el-tabs {
        width: 100%;
        .el-tabs__header {
          width: 1360px;
          margin: 0 auto;
        }
        .el-tabs__nav-scroll {
          display: flex;
          justify-content: center;
          .el-tabs__nav {
            // width: 100%;
          }
        }
      }
    }
  }
  .project_left {
    width: 854px;
    height: 292px;
    background: #d8d8d8;
    border-radius: 5px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .project_right {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 25px 25px 0 25px;
    box-sizing: border-box;
    flex: 1;
    height: 292px;
    flex-wrap: wrap;
    flex: 1;
    border-right: 1px solid #cfcfcf;
    &.others {
      margin-top: 45px;
      padding: 0 25px;
      height: 200px;
      .line {
        &.title {
          margin-top: 20px;
          margin-bottom: 40px;
        }
      }
    }
    &:first-child {
      padding-left: 0;
    }
    &:last-child {
      padding-right: 0;
      border: none;
    }
    .line {
      width: 100%;
      .normal_flex;
      justify-content: space-between;
      .date {
        font-size: 34px;
        font-family: Roboto-Bold, Roboto;
        font-weight: bold;
        color: #262626;
        line-height: 45px;
      }
      .year {
        font-size: 30px;
        font-family: Roboto-Regular, Roboto;
        font-weight: 400;
        color: #99999933;
        line-height: 19px;
      }
      &.time {
        margin-top: 6px;
        font-size: 20px;
        font-family: Roboto-Regular, Roboto;
        font-weight: 400;
        color: #999999;
        line-height: 19px;
      }
      &.title {
        margin-top: 75px;
        margin-bottom: 32px;
        font-size: 16px;
        font-family: PingFang-SC-Medium, PingFang-SC;
        font-weight: 500;
        color: #262626;
        line-height: 27px;
      }
      &.desc {
        justify-content: flex-start;
        font-size: 14px;
        font-family: PingFang-SC-Regular, PingFang-SC;
        font-weight: 400;
        color: #262626;
        line-height: 19px;
        .position_icon {
          width: 12px;
          height: 13px;
          margin-right: 5px;
        }
      }
    }
    .project_item {
      width: 448px;
      height: 390px;
      box-shadow: 0px 3px 16px -8px rgba(47, 47, 47, 0.21);
      border-radius: 5px;
    }
  }
}
@media screen and (max-width: 1024px) {
  .home_component {
    padding-top: 2.5rem !important;
  }
  .inner_box {
    column-count: 1 !important;
    column-gap: 1.2333rem;
  }
  .inner_m {
    position: relative;
    margin-bottom: 1.0125rem !important;
  }
  .artwork_box {
    width: 9.2rem !important;
    height: 6.5333rem !important;
    border-radius: 8px;
    overflow: hidden;
    position: relative;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  }
  .artwork_class {
    width: 9.2rem !important;
    height: 6.5333rem !important;
    border-radius: 8px;
    overflow: hidden;
    position: relative;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  }
  .inner_box .artwork_title {
    font-size: 0.48rem !important;
  }
  .inner_box .artwork_name {
    font-size: 0.3733rem !important;
  }
  .news_and_info .component_box .inner_box .artwork {
    position: absolute;
    width: 0.8rem;
    height: 0.8rem;
    top: 0.4rem;
    left: 0.4rem;
    cursor: pointer;
  }
  .view_more {
    display: none;
  }
  .artwork_contemt {
    display: none !important;
  }
}
.project_item {
  position: relative;
  overflow: hidden;
  border-radius: 6px 6px 6px 6px;
  width: 700px;
  height: 416px;
  box-sizing: border-box;
  .normal_flex;
  .fd_column;
  justify-content: space-between;

  font-size: 16px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #323233;
  line-height: 27px;
  img {
    width: 100%;
    height: 100%;
  }
  .title {
    box-sizing: border-box;
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 70px;
    padding: 0 30px;
    background: rgba(0, 0, 0, 0.43);
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 16px;
    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
    font-weight: 500;
    color: #ffffff;
    line-height: 27px;
  }
}
</style>
<style lang="less"></style>
